import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Competition_entry } from '../models/competition_entry';
import { AppSettings } from '../app.settings';


@Injectable({
  providedIn: 'root'
})
export class NominatingFeeService {

  constructor(private http: HttpClient) { }


public doesNominatingFeeApply(horse_show_id: string, billing_code: string, pending_competition_entries: Competition_entry[]): Promise<boolean> {
    let put_data = {
          data: {
            type: 'nominating_fee_applicability_request',
            attributes: {horse_show_id: horse_show_id, billing_code: billing_code, pending_competition_entries: pending_competition_entries}
           }
        };

    return new Promise((resolve, reject) => {
      return this.http.put(AppSettings.API_ENDPOINT + 'accounting/nominating_fees',
        put_data, AppSettings.DEFAULT_HTTP_OPTIONS).subscribe((response: any) => {
        	//Don't just test for response.data because server returns specific data value of false - which will cause this to reject promise, test for null instead
          if(response.data != null && response.type=='nominating_fee_applicability_response') {
               	resolve(response.data);
               }  else {
                 reject(response);
               }

        }, error => {
          if(error instanceof HttpErrorResponse){
            reject(error.error);
          } else {
            reject(error);
          }
        });
    });
  }

}
